import {isPlatformBrowser} from "@angular/common";
import {Component, inject, type OnDestroy, PLATFORM_ID, signal} from "@angular/core";
import {NgbToast, NgbToastHeader} from "@ng-bootstrap/ng-bootstrap";
import type {BootstrapIconsId} from "bootstrap-icons";
import {BootstrapIcon} from "../../directives/bootstrap-icon";
import {type IdentifiableToast, ToastType} from "../../models/Toast";
import {Toasts} from "../../services/toasts";

type ToastClass = "toast-success" | "toast-info" | "toast-warning" | "toast-error";

@Component({
  selector: "rf-toasts-overlay",
  templateUrl: "./toasts-overlay.html",
  styleUrl: "./toasts-overlay.scss",
  imports: [
    BootstrapIcon,
    NgbToast,
    NgbToastHeader,
  ],
})
export class ToastsOverlay implements OnDestroy {
  protected readonly toasts = inject(Toasts);

  protected readonly autoHide = signal(isPlatformBrowser(inject(PLATFORM_ID)));

  protected getToastClass(toastType: ToastType): ToastClass {
    switch (toastType) {
      case ToastType.Success:
        return "toast-success";
      case ToastType.Info:
        return "toast-info";
      case ToastType.Warning:
        return "toast-warning";
      case ToastType.Error:
        return "toast-error";
    }
  }

  protected getToastIcon(toastType: ToastType): BootstrapIconsId {
    switch (toastType) {
      case ToastType.Success:
        return "check2-circle";
      case ToastType.Info:
        return "info-circle";
      case ToastType.Warning:
        return "exclamation-triangle";
      case ToastType.Error:
        return "exclamation-circle";
    }
  }

  protected toastHidden(toast: Readonly<IdentifiableToast>): void {
    this.autoHide.set(true);
    this.toasts.remove(toast);
  }

  public ngOnDestroy(): void {
    this.toasts.clear();
  }
}
